import React from 'react';
import isFunction from 'lodash/isFunction';
export default (function (maybeComponent) {
  return /*#__PURE__*/React.isValidElement(maybeComponent) || isFunction(maybeComponent);
});